<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <b-card :title="$t('message.Share_0')">
        <b-card-text>
          <p class="text-justify">
            <b-badge pill variant="danger">1</b-badge>
            {{$t('message.Share_1')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">2</b-badge>
            {{$t('message.Share_2')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">3</b-badge>
            {{$t('message.Share_3')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">4</b-badge>
            {{$t('message.Share_4')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">5</b-badge>
            {{$t('message.Share_5')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">6</b-badge>
            {{$t('message.Share_6')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">7</b-badge>
            {{$t('message.Share_7')}}
          </p>
          <p class="text-justify">
            <b-badge pill variant="danger">8</b-badge>
            {{$t('message.Share_8')}}
          </p>
        </b-card-text>
      </b-card>
    </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HeadSection from "./HeadSection.vue";
import FootSection from "./FootSection.vue";
export default {
  name: "Share",
  components: { HeadSection, FootSection },
  computed: {
    ...mapGetters(["lan", "access_token"])
  },
  created() {
    if (this.access_token == "") this.toHome();
    else this.isMem();
  },
  watch: {
    lan(newlan, oldlan) {
      if (this.access_token == "") this.toHome();
      else this.isMem();
    }
  },
  methods: {
    ...mapActions({
      isMem(dispatch) {
        dispatch("isMem", {}).then(data => {
          if (!data.result) {
            this.toHome();
          }
        });
      }
    }),
    toHome() {
        this.$router.push({
          name: "enhome"
        });
    }
  }
};
</script>

